import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import LongtailPaymentList from '~pages/payment/long-tail/list';
import LongtailPaymentSetup from '~pages/payment/long-tail/setup';
import PaymentCallback from '~pages/payment/callback';
import * as authActions from '~actions/auth';
import generatePath from '~client/settings/routing';

const mapStateToProps = state => ({
  token: state.auth.getIn(['base', 'token']),
  listCommunication: state.payment.getIn(['properties', 'communication']).toJS(),
  hasHerculesProperties: state.auth.getIn(['properties', 'hasHerculesProperties']),
  hasInstantBookProperties: state.auth.getIn(['properties', 'hasInstantBookProperties']),
});

const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch(authActions.logout());
  },
  getLandlordType: () => {
    dispatch(authActions.getLandlordType());
  },
});

@connect(mapStateToProps, mapDispatchToProps)
export default class PaymentDashboard extends React.Component {
  componentDidUpdate() {
    if (this.props.listCommunication.errorInfo.statusCode === 401) {
      this.props.logout();
    }
  }
  componentDidMount() {
    this.props.getLandlordType();
  }

  render() {
    if (!this.props.token || this.props.token.length === 0) {
      return (
        <Redirect
          to={generatePath(
            'login',
            {},
            {
              redirectUrl: this.props.match.url,
            },
          )}
        />
      );
    }

    // if (this.props.hasHerculesProperties !== null && !this.props.hasHerculesProperties) {
    //   return <Redirect to={generatePath('board')} />;
    // }

    return (
      <div className="payment container">
        <div className="payment__container payment__container--long-tail loading-wrapper">
          <Switch>
            {/* Longtail */}
            <Route
              path="/payment/setup/:step?"
              render={props => (
                <LongtailPaymentSetup {...props} hasKeyProperty={this.props.hasKeyProperty} />
              )}
            />
            <Route path="/payment/list" component={LongtailPaymentList} />
            <Route path="/payment/callback" component={PaymentCallback} />
          </Switch>
        </div>
      </div>
    );
  }
}

PaymentDashboard.propTypes = {
  listCommunication: PropTypes.shape({
    errorInfo: PropTypes.shape({
      statusCode: PropTypes.number,
    }),
  }),
  token: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  hasHerculesProperties: PropTypes.bool.isRequired,
  hasInstantBookProperties: PropTypes.bool.isRequired,
};

PaymentDashboard.defaultProps = {
  listCommunication: {
    errorInfo: {
      statusCode: 200,
    },
  },
  token: '',
  logout: () => {},
  match: {
    url: '',
  },
};
